<template>
  <div class="record-upload">
    <el-drawer
      v-model="visible"
      append-to-body
      class="record-upload-drawer"
      direction="btt"
      :show-close="false"
      size="50%"
      :with-header="false"
    >
      <div v-if="attributes.isEnding" class="ru-drawer-box">
        <div class="ru-drawer-header">
          <i class="icon-close-large-line t-iconfont" @click="closeDrawer"></i>
          {{ title }}
        </div>
        <div class="ru-drawer-center">
          <RecordCard
            v-if="!orderNo"
            :audio-url="audioUrl"
            :audio-url-blob="isAi ? audioUrl : audioUrlBlob"
            class="center-aiduo"
            :progress="progress"
            :upload-time="uploadTime"
          ></RecordCard>
          <template v-else>
            <RecordViewCard :upload-time="uploadTime" />
          </template>
          <div class="center-column">
            <!-- 自动 -->
            <!-- <FormCardAuto ref="dataFormAuto" v-if="attributes.storageConfigInfo.warehouseType === 2" :attributes="attributes"></FormCardAuto> -->
            <FormCardAuto
              ref="dataFormAuto"
              :attributes="attributes"
              :is-auto="isAuto"
              :is-visit="isVisit"
              :visit-item="visitItem"
            ></FormCardAuto>
            <!-- 手动 -->
            <!-- <FormCard ref="dataForm" v-else :attributes="attributes"></FormCard> -->
          </div>
        </div>
        <div class="ru-drawer-button">
          <div v-if="orderNo && isVisit" class="button-container">
            <el-button
              class="button-submit"
              color="#7a52f4"
              :disabled="showClue"
              @click="submitQuickCreate"
              >完成跟进</el-button
            >
            <div v-if="showClue" class="upload-tips">
              录音已上传，后续可以关联选中该录音，无需在此等待
            </div>
          </div>
          <template v-else>
            <el-button class="button-cancel" @click="getNewData">重选录音</el-button>
            <el-button
              class="button-submit"
              color="#7a52f4"
              :disabled="showClue && isVisit"
              @click="submitQuickCreate"
              >确定</el-button
            >
          </template>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script setup>
import { computed, onMounted, ref } from 'vue'
import { quickActionsCreateTask, getMeetingAssistantConfig, sendBadge, submitAnalysis } from '@/api'
import RecordCard from '@/components/follow-record/record-card.vue'
import FormCardAuto from '@/components/follow-record/form-card-auto.vue'
import AppMessage from '@/components/message/index.js'

import RecordViewCard from './record-view-card.vue'

defineOptions({
  name: 'RecordUpload'
})

const props = defineProps({
  recordUploadVisible: {
    type: Boolean,
    default: false
  },
  title: {
    type: String,
    default: '上传本地音/视频'
  },
  audioUrl: {
    type: String,
    default: ''
  },
  audioUrlBlob: {
    type: String,
    default: ''
  },
  fileSize: {
    type: Number,
    default: undefined
  },
  progress: {
    type: Number,
    default: 0
  },
  isAi: {
    type: Boolean,
    default: false
  },
  isVisit: {
    type: Boolean,
    default: false
  },
  visitItem: {
    type: Object,
    default: () => ({})
  },
  aiAudioId: {
    type: [String, Number],
    default: ''
  },
  uploadTime: {
    type: String,
    default: ''
  },
  orderNo: {
    type: String,
    default: ''
  }
})

const dataFormAuto = ref(null)
// const dataForm = ref(null)
const emits = defineEmits(['update:recordUploadVisible', 'getClose', 'getAiLIst', 'getReset'])

const isAuto = ref(true)
// 入库配置信息
const attributes = ref({ storageConfigInfo: {} })

const showClue = computed(() => dataFormAuto.value && dataFormAuto.value.showClue)

const visible = computed({
  get: () => props.recordUploadVisible,
  set: (val) => {
    emits('update:recordUploadVisible', val)
  }
})

// 提交
const submitQuickCreate = async () => {
  console.log('🍊🍊：', dataFormAuto.value.formData)
  console.log('🍊🍊🍊：', dataFormAuto.value.submitDataCache)
  console.log('🍊🍊🍊🍊：', attributes)
  console.log('🍊🍊🍊🍊🍊：', dataFormAuto.value.followUpObject)

  const submitValid = await dataFormAuto.value.handleSubmit()
  if (!submitValid) return

  const params = dataFormAuto.value.formData
  const paramsSubmit = dataFormAuto.value.submitDataCache
  if (!paramsSubmit.rule.id) {
    AppMessage.error('未选择分析模板')
    return
  }
  let API = quickActionsCreateTask
  const paramsDate = {
    ruleId: params.ruleId,
    ruleName: paramsSubmit.rule.name,
    fileUrl: props.audioUrl,
    shortcutRefId:
      dataFormAuto.value.followUpObject === 100 ? params.customer.id : paramsSubmit.customer.id, // 客户线索id
    shortcutRefName:
      dataFormAuto.value.followUpObject === 100 ? params.customer.name : paramsSubmit.customer.name, // 客户线索name
    shortcutRefType: dataFormAuto.value.followUpObject, // businessType
    autoWarehouseTag: attributes.value.storageConfigInfo.warehouseType,
    homePageChatInfo: {
      id: paramsSubmit.rule.id, // 模板
      name: paramsSubmit.rule.name, // 模板
      rule: { ...paramsSubmit.rule, required: true }, // 模板
      opportunity: paramsSubmit.opportunity, // 机会
      customer: dataFormAuto.value.followUpObject === 100 ? params.customer : paramsSubmit.customer, // 线索和客户
      businessType: dataFormAuto.value.followUpObject
    }
  }
  if (props.fileSize !== undefined) {
    paramsDate.needCabinet = 1
    paramsDate.fileSize = props.fileSize
  }
  const nameData =
    dataFormAuto.value.followUpObject === 8000 ? 'clueCommunicateTypeInfo' : 'communicateTypeInfo'
  paramsSubmit.communicateTypeInfo?.id &&
    (paramsDate.homePageChatInfo[nameData] = {
      value: paramsSubmit.communicateTypeInfo?.id,
      text: paramsSubmit.communicateTypeInfo?.name,
      required: paramsSubmit.communicateTypeInfo?.required
    })
  if (props.isVisit) {
    paramsDate.communicatePlanId = props.visitItem.communicatePlanId
  }
  if (props.orderNo && props.isVisit) {
    // 日程助手 -> 跟进分析->录音->提交分析
    API = submitAnalysis
    paramsDate.orderNo = props.orderNo
  }
  const res = await API(paramsDate)
  if (res.success) {
    if (props.isAi) {
      await sendBadge({ dataId: props.aiAudioId })
    }
    AppMessage.success(
      `${
        attributes.value.storageConfigInfo.warehouseType === 2
          ? '上传成功，分析完成后将为您推送结果'
          : '上传成功，稍后请去「跟进助手」入库跟进'
      }`
    )
    if (props.isAi) emits('getClose')
    visible.value = false
  }
}

// 获取是自动还是手动入库
const getTheMeetingAssistantConfig = async () => {
  const { result } = await getMeetingAssistantConfig({
    type: 4
  })
  if (result?.data) {
    let storageConfigInfo = {}
    // try {
    storageConfigInfo = JSON.parse(result.data.config || '{}')
    if (!storageConfigInfo.followUpObject) {
      storageConfigInfo.followUpObject = 100
    }
    console.log('🍊', storageConfigInfo)
    isAuto.value = storageConfigInfo.warehouseType === 2
    // // 只有纯线索的时候，用线索的逻辑
    // if(storageConfigInfo.followUpObject === 8000) {

    // }
    // 拼接attributes
    attributes.value = {
      opportunity: storageConfigInfo.fields[0] || {}, // 销售机会
      communicateTypeInfo:
        storageConfigInfo.followUpObject === 8000 && storageConfigInfo.warehouseType === 2
          ? storageConfigInfo.clueFields[0]
          : storageConfigInfo.fields[1] || {}, // 跟进记录
      rule: {}, // 模板
      // id: '',
      storageConfigInfo: { ...storageConfigInfo },
      businessType: storageConfigInfo.businessTypes,
      // rule: {},
      // customer: {},
      storeTag: 0,
      isEnding: true
    }
    // } catch (err) {
    //   console.error('解析入库方式配置信息失败', err)
    // }
  }
}

const closeDrawer = () => {
  visible.value = false
}

const getNewData = () => {
  if (props.isAi) {
    emits('getAiLIst')
  } else {
    emits('getReset')
    // 重选录音不关闭当前弹窗
    // visible.value = false
  }
}

onMounted(async () => {
  // 获取最新配置信息
  await getTheMeetingAssistantConfig()
  // console.log('storageConfigInfo:', storageConfigInfo)
})
</script>

<style lang="scss">
.record-upload-drawer {
  border-radius: 24px 24px 0px 0px;
  .el-drawer__body {
    border-radius: 24px 24px 0px 0px;
    overflow: hidden;
  }
  .ru-drawer-box {
    height: 100%;
    display: flex;
    flex-direction: column;
    .ru-drawer-header {
      height: 48px;
      font-size: 16px;
      font-weight: 600;
      text-align: center;
      line-height: 48px;
      position: relative;
      flex-shrink: 0;
      .icon-close-large-line {
        position: absolute;
        left: 24px;
        color: #c9cdd4;
      }
    }
    .ru-drawer-center {
      flex: 1;
      padding: 12px;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      overflow: auto;
      .center-aiduo {
        flex-shrink: 0;
      }
      .center-column {
        flex: 1;
        overflow: auto;
      }
    }
    .ru-drawer-button {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 12px calc(12px + env(safe-area-inset-bottom)) 12px;
      .button-cancel,
      .button-submit {
        flex: 1;
        height: 36px;
        font-size: 14px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 64px;
        font-weight: unset;
      }
      // 先取消手机端 hover 状态
      .button-cancel:hover {
        color: var(--el-button-text-color);
        background-color: var(--el-button-bg-color);
        border-color: var(--el-button-border-color);
      }
      .button-container {
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        .button-submit {
          width: 100%;
          height: 36px;
          font-size: 14px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 64px;
        }

        .upload-tips {
          margin-top: 12px;
          font-size: 12px;
          line-height: 16px;
          color: #9e9e9e;
        }
      }
    }
  }
  .audio-player__play {
    margin: 0 14px 0 0 !important;
  }
  .icon-play-circle-fill,
  .icon-pause-circle-fill {
    font-size: 20px !important;
  }
  .record-item__header {
    margin-bottom: 0px !important;
  }
  .record-item {
    padding: 12px 12px 6px 12px !important;
  }
  .el-slider {
    margin-left: 5px !important;
  }
  .center-column {
    overflow-y: scroll; /* 确保内容可滚动 */
    -ms-overflow-style: none; /* IE/Edge */
    scrollbar-width: none; /* Firefox */
  }

  .center-column::-webkit-scrollbar {
    display: none; /* Chrome/Safari/WebKit */
  }
}
</style>
